import { MymeEditorCategory, UUID } from '@myme/utils';
import i18n from 'i18next';

export interface MymeChip {
  id: UUID;
  name: string;
}

export interface MymeChipState extends MymeChip {
  isSelected: boolean;
}

export const mymeTypesAsChips: MymeChip[] = [
  {
    id: 'LOCATION_BASED',
    name: i18n.t('pages.feed.myme.type.location_based')
  },
  {
    id: 'TIME_BASED',
    name: i18n.t('pages.feed.myme.type.time_based')
  },
  {
    id: 'COURSE',
    name: i18n.t('pages.feed.myme.type.course')
  }
];

export const getInitialChips = (categories: MymeEditorCategory[]): MymeChipState[] => {
  const allChips = [...mymeTypesAsChips, ...categories];

  return allChips.map(chip => ({ ...chip, isSelected: false }));
};
